<ng-container *ngIf="signatures$ | async as signatures; else noSignatures">
  <div class="w-full overflow-x-auto">
    <table class="table" *ngIf="signatures.length; else noSignatures">
      <thead>
        <tr>
          <th>Name</th>
          <th>Date</th>
          <th>User</th>
          <th>Stage</th>
          <th>Image</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let signature of signatures">
          <td>{{ signature.print_name }}</td>
          <td>{{ signature.created_at | amDateFormat : dateTimeFormat }}</td>
          <td>{{ signature.recorded_by | userIdToName | async }}</td>
          <td>{{ signature.stage }}</td>
          <td>
            <img
              class="w-64 border border-gray-200"
              [src]="signature?.signature_image_url"
            />
          </td>
          <td>
            <span class="show-on-hover">
              <a (click)="deleteSignature(signature)">Delete</a></span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #noSignatures>
  <p class="italic text-gray-700 tracking-wide mt-2 mb-2">
    No signatures recorded yet.
  </p>
</ng-template>
